import React from "react";
import theme from "theme";
import { Theme, Link, Image, Section, Text, Box, Strong } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { Override, SocialMedia } from "@quarkly/components";
import * as Components from "components";
import { MdMenu } from "react-icons/md";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"team"} />
		<Helmet>
			<title>
				Team | Website Example
			</title>
			<meta name={"description"} content={"It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."} />
			<meta property={"og:title"} content={"Team | Website Example"} />
			<meta property={"og:description"} content={"It all begins with an idea. Maybe you want to launch a business. Maybe you want to turn a hobby into something bigger. Or maybe you have a creative project to share with the world. Whatever it is, the way you tell your story online can make all the difference."} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/website-example-quarkly.png?v=2020-11-05T19:48:01.806Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/favicon-32x32.png?v=2025-02-06T21:45:55.970Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/apple-touch-icon.png?v=2025-02-06T21:46:06.416Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/apple-touch-icon.png?v=2025-02-06T21:46:06.416Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/apple-touch-icon.png?v=2025-02-06T21:46:06.416Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/apple-touch-icon.png?v=2025-02-06T21:46:06.416Z"} />
		</Helmet>
		<Section padding="16px 0 16px 0" quarkly-title="Header" align-items="center" justify-content="center">
			<Override
				slot="SectionContent"
				md-margin="0px 16px 0px 16px"
				display="grid"
				grid-template-columns="repeat(3, 1fr)"
				md-grid-template-columns="repeat(2, 1fr)"
				margin="0px 32px 0px 32px"
				width="100%"
			/>
			<Link href="/" position="relative" transition="opacity 200ms ease" quarkly-title="Link">
				<Image
					src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16:03:14.619Z"
					width="120px"
					z-index="3"
					srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Pantry%20Logo%20-%20Black%20250px_lores.png?v=2025-01-28T16%3A03%3A14.619Z&quality=85&w=3200 3200w"
					sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
				/>
			</Link>
			<Components.BurgerMenu md-align-items="center" md-justify-content="flex-end" md-display="flex">
				<Override
					slot="menu-open"
					md-bottom={0}
					md-display="flex"
					md-flex-direction="column"
					md-align-items="center"
					md-justify-content="center"
					md-top={0}
				/>
				<Override slot="icon-open" md-right="18px" md-position="fixed" md-top="18px" />
				<Override
					slot="menu"
					lg-transition="transform 400ms ease 0s"
					md-top={0}
					align-items="center"
					md-height="100%"
					padding="0px 0 0px 0"
					justify-content="center"
					lg-transform="translateY(0px) translateX(0px)"
					md-position="fixed"
					display="flex"
					md-left={0}
					md-width="100%"
				>
					<Override
						slot="item"
						padding="8px 20px 8px 20px"
						md-padding="16px 40px 16px 40px"
						display="inline-block"
						text-transform="uppercase"
						text-align="center"
					/>
					<Override slot="item-404" lg-display="none" display="none" />
					<Override slot="item-index" lg-display="none" display="none" />
					<Override
						slot="link"
						color="--dark"
						letter-spacing="0.5px"
						md-transition="opacity .15s ease 0s"
						font="--base"
						text-transform="initial"
						md-font="16px/24px sans-serif"
						transition="opacity .15s ease 0s"
						text-decoration-line="initial"
						opacity=".5"
						md-color="--dark"
						md-opacity=".5"
						hover-opacity="1"
						md-hover-opacity="1"
						md-active-opacity="1"
					/>
					<Override
						slot="link-active"
						md-opacity="1"
						md-cursor="default"
						opacity="1"
						color="--primary"
						cursor="default"
					/>
				</Override>
				<Override slot="icon,icon-close" category="md" icon={MdMenu} />
				<Override
					slot="icon"
					category="md"
					icon={MdMenu}
					size="36px"
					md-right="0px"
					md-position="relative"
				/>
			</Components.BurgerMenu>
		</Section>
		<Section quarkly-title="Hero" padding="25px 0 75px 0" lg-padding="25px 0 25px 0" justify-content="center">
			<Override
				slot="SectionContent"
				min-width="auto"
				width="100%"
				margin="0px 32px 0px 32px"
				md-margin="0px 16px 0px 16px"
			/>
			<Box
				display="flex"
				align-items="center"
				justify-content="center"
				background="radial-gradient(at center,--color-darkL2 23.3%,rgba(0,0,0,0) 82.4%),linear-gradient(180deg,rgba(155, 108, 252, 0.15) 0%,transparent 100%) 0 0 no-repeat,--color-darkL2"
				md-min-height="360px"
				sm-min-height="180px"
				width="100%"
				min-height="480px"
			>
				<Text
					font="--headline1"
					align-items="center"
					justify-content="center"
					quarkly-title="Title"
					sm-text-align="center"
					md-font="--headline2"
					lg-font="--headline2"
					margin="0px 0px 0px 0px"
					display="flex"
					color="--light"
					sm-font="normal 900 42px/1.2 -apple-system, system-ui, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
					text-align="center"
				>
					Services
					<br />
				</Text>
			</Box>
		</Section>
		<Section
			border-width="1px 0px 1px 0px"
			justify-content="center"
			sm-padding="0px 0 0px 0"
			quarkly-title="About"
			padding="90px 0px 100px 0px"
			border-style="solid"
			box-sizing="border-box"
			background="--color-lightD1"
			border-color="--color-lightD2"
			lg-padding="50px 0px 50px 0px"
		>
			<Override
				slot="SectionContent"
				sm-padding="24px 0px 24px 0px"
				width="100%"
				md-margin="0px 16px 0px 16px"
				min-width="auto"
				align-items="center"
				margin="0px 32px 0px 32px"
			/>
			<Text
				font="--base"
				letter-spacing="1px"
				margin="0px 0px 10px 0px"
				color="--dark"
				lg-text-align="center"
				quarkly-title="Title"
				text-align="center"
				opacity="0.6"
				lg-margin="0px 0px 6px 0px"
				text-transform="uppercase"
			>
				what we offer
			</Text>
			<Text
				color="--dark"
				text-align="left"
				width="85%"
				lg-font="--lead"
				sm-font="--base"
				font="--headline3"
				margin="0px 0px 0px 0px"
				letter-spacing="1px"
			>
				Mastering
				<br />
				<br />
				Our mastering services refine your track, ensuring clarity, balance, and the right dynamics for any platform. We tailor our approach to match your artistic vision.
				<br />
				<br />
				Mixing
				<br />
				<br />
				Professional mixing to enhance depth, punch, and cohesion, ensuring every element in your track shines while maintaining sonic balance.
				<br />
				<br />
				Collaboration
				<br />
				<br />
				We work with independent artists, major labels, and production teams across TV, film, and advertising to deliver high-quality sound on all your projects
			</Text>
		</Section>
		<Section padding="65px 0 65px 0" sm-padding="60px 0 60px 0" quarkly-title="Images-17">
			<Override slot="SectionContent" flex-direction="row" flex-wrap="wrap" />
			<Box
				sm-grid-template-columns="repeat(2, 1fr)"
				grid-auto-flow="row"
				grid-template-columns="repeat(8, 1fr)"
				grid-gap="10px 10px"
				grid-template-rows="repeat(2, 117px)"
				lg-grid-template-rows="repeat(4, 117px)"
				lg-align-self="center"
				lg-grid-gap="36px"
				width="100%"
				display="grid"
				padding="16px 0px 16px 0px"
				lg-grid-template-columns="repeat(4, 1fr)"
			>
				<Box
					overflow-x="hidden"
					transform="translateY(0px)"
					display="flex"
					align-items="center"
					justify-content="center"
					overflow-y="hidden"
					position="relative"
					transition="transform 0.2s ease-in-out 0s"
					hover-transform="translateY(-10px)"
					padding="0px 0px 0px 0px"
				>
					<Image
						object-fit="cover"
						position="relative"
						width="112px"
						left={0}
						right={0}
						bottom="0px"
						min-height="100%"
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0066.jpg?v=2025-02-07T12:10:33.270Z"
						display="block"
						top="auto"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0066.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0066.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0066.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0066.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0066.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0066.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0066.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					display="flex"
					overflow-y="hidden"
					transition="transform 0.2s ease-in-out 0s"
					lg-justify-content="center"
					hover-transform="translateY(-10px)"
					padding="0px 0px 0px 0px"
					lg-align-items="center"
					lg-display="flex"
					align-items="center"
					overflow-x="hidden"
					position="relative"
					transform="translateY(0px)"
					justify-content="center"
				>
					<Image
						bottom="0px"
						width="112px"
						left={0}
						position="relative"
						display="block"
						top="auto"
						right={0}
						min-height="100%"
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0484.jpg?v=2025-02-07T12:10:33.263Z"
						object-fit="cover"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0484.jpg?v=2025-02-07T12%3A10%3A33.263Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0484.jpg?v=2025-02-07T12%3A10%3A33.263Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0484.jpg?v=2025-02-07T12%3A10%3A33.263Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0484.jpg?v=2025-02-07T12%3A10%3A33.263Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0484.jpg?v=2025-02-07T12%3A10%3A33.263Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0484.jpg?v=2025-02-07T12%3A10%3A33.263Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0484.jpg?v=2025-02-07T12%3A10%3A33.263Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					padding="0px 0px 0px 0px"
					justify-content="center"
					overflow-x="hidden"
					overflow-y="hidden"
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					display="flex"
					position="relative"
					hover-transform="translateY(-10px)"
					lg-display="flex"
					align-items="center"
				>
					<Image
						width="112px"
						top="auto"
						right={0}
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0561.jpg?v=2025-02-07T12:10:33.286Z"
						position="relative"
						display="block"
						left={0}
						bottom="0px"
						min-height="100%"
						height="112px"
						object-fit="cover"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0561.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0561.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0561.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0561.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0561.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0561.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0561.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					padding="0px 0px 0px 0px"
					align-items="center"
					display="flex"
					overflow-x="hidden"
					overflow-y="hidden"
					position="relative"
					transform="translateY(0px)"
					hover-transform="translateY(-10px)"
					transition="transform 0.2s ease-in-out 0s"
					justify-content="center"
				>
					<Image
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0062.jpg?v=2025-02-07T12:10:33.290Z"
						object-fit="cover"
						top="auto"
						left={0}
						bottom="0px"
						min-height="100%"
						height="112px"
						position="relative"
						display="block"
						width="112px"
						right={0}
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0062.jpg?v=2025-02-07T12%3A10%3A33.290Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0062.jpg?v=2025-02-07T12%3A10%3A33.290Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0062.jpg?v=2025-02-07T12%3A10%3A33.290Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0062.jpg?v=2025-02-07T12%3A10%3A33.290Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0062.jpg?v=2025-02-07T12%3A10%3A33.290Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0062.jpg?v=2025-02-07T12%3A10%3A33.290Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0062.jpg?v=2025-02-07T12%3A10%3A33.290Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					position="relative"
					padding="0px 0px 0px 0px"
					overflow-x="hidden"
					overflow-y="hidden"
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					hover-transform="translateY(-10px)"
					align-items="center"
					display="flex"
					justify-content="center"
				>
					<Image
						top="auto"
						bottom="0px"
						min-height="100%"
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/AB-C0271.jpg?v=2025-02-07T12:10:33.282Z"
						object-fit="cover"
						position="relative"
						display="block"
						width="112px"
						left={0}
						right={0}
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AB-C0271.jpg?v=2025-02-07T12%3A10%3A33.282Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AB-C0271.jpg?v=2025-02-07T12%3A10%3A33.282Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AB-C0271.jpg?v=2025-02-07T12%3A10%3A33.282Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AB-C0271.jpg?v=2025-02-07T12%3A10%3A33.282Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AB-C0271.jpg?v=2025-02-07T12%3A10%3A33.282Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AB-C0271.jpg?v=2025-02-07T12%3A10%3A33.282Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AB-C0271.jpg?v=2025-02-07T12%3A10%3A33.282Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					overflow-y="hidden"
					transform="translateY(0px)"
					hover-transform="translateY(-10px)"
					justify-content="center"
					overflow-x="hidden"
					position="relative"
					transition="transform 0.2s ease-in-out 0s"
					padding="0px 0px 0px 0px"
					align-items="center"
					display="flex"
				>
					<Image
						display="block"
						top="auto"
						bottom="0px"
						min-height="100%"
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0122.jpg?v=2025-02-07T22:53:32.465Z"
						object-fit="cover"
						position="relative"
						width="112px"
						left={0}
						right={0}
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0122.jpg?v=2025-02-07T22%3A53%3A32.465Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0122.jpg?v=2025-02-07T22%3A53%3A32.465Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0122.jpg?v=2025-02-07T22%3A53%3A32.465Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0122.jpg?v=2025-02-07T22%3A53%3A32.465Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0122.jpg?v=2025-02-07T22%3A53%3A32.465Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0122.jpg?v=2025-02-07T22%3A53%3A32.465Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0122.jpg?v=2025-02-07T22%3A53%3A32.465Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					overflow-x="hidden"
					transform="translateY(0px)"
					hover-transform="translateY(-10px)"
					padding="0px 0px 0px 0px"
					align-items="center"
					display="flex"
					overflow-y="hidden"
					position="relative"
					transition="transform 0.2s ease-in-out 0s"
					justify-content="center"
				>
					<Image
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0056.jpg?v=2025-02-07T12:10:33.286Z"
						object-fit="cover"
						width="112px"
						left={0}
						bottom="0px"
						min-height="100%"
						position="relative"
						display="block"
						top="auto"
						right={0}
						height="112px"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0056.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0056.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0056.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0056.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0056.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0056.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVT0056.jpg?v=2025-02-07T12%3A10%3A33.286Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					overflow-x="hidden"
					overflow-y="hidden"
					transition="transform 0.2s ease-in-out 0s"
					padding="0px 0px 0px 0px"
					display="flex"
					position="relative"
					transform="translateY(0px)"
					hover-transform="translateY(-10px)"
					align-items="center"
					justify-content="center"
				>
					<Image
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/portraits_seanhargreaves.jpg?v=2025-02-07T12:10:33.276Z"
						width="112px"
						min-height="100%"
						height="112px"
						object-fit="cover"
						position="relative"
						display="block"
						top="auto"
						left={0}
						right={0}
						bottom="0px"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/portraits_seanhargreaves.jpg?v=2025-02-07T12%3A10%3A33.276Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/portraits_seanhargreaves.jpg?v=2025-02-07T12%3A10%3A33.276Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/portraits_seanhargreaves.jpg?v=2025-02-07T12%3A10%3A33.276Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/portraits_seanhargreaves.jpg?v=2025-02-07T12%3A10%3A33.276Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/portraits_seanhargreaves.jpg?v=2025-02-07T12%3A10%3A33.276Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/portraits_seanhargreaves.jpg?v=2025-02-07T12%3A10%3A33.276Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/portraits_seanhargreaves.jpg?v=2025-02-07T12%3A10%3A33.276Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					display="flex"
					position="relative"
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					hover-transform="translateY(-10px)"
					padding="0px 0px 0px 0px"
					align-items="center"
					overflow-x="hidden"
					overflow-y="hidden"
					justify-content="center"
				>
					<Image
						object-fit="cover"
						width="112px"
						bottom="0px"
						min-height="100%"
						left={0}
						right={0}
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0400.jpg?v=2025-02-07T12:10:33.273Z"
						position="relative"
						display="block"
						top="auto"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0400.jpg?v=2025-02-07T12%3A10%3A33.273Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0400.jpg?v=2025-02-07T12%3A10%3A33.273Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0400.jpg?v=2025-02-07T12%3A10%3A33.273Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0400.jpg?v=2025-02-07T12%3A10%3A33.273Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0400.jpg?v=2025-02-07T12%3A10%3A33.273Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0400.jpg?v=2025-02-07T12%3A10%3A33.273Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0400.jpg?v=2025-02-07T12%3A10%3A33.273Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					hover-transform="translateY(-10px)"
					padding="0px 0px 0px 0px"
					align-items="center"
					display="flex"
					justify-content="center"
					position="relative"
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					overflow-x="hidden"
					overflow-y="hidden"
				>
					<Image
						min-height="100%"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0517.jpg?v=2025-02-07T12:10:33.270Z"
						position="relative"
						display="block"
						width="112px"
						top="auto"
						bottom="0px"
						object-fit="cover"
						left={0}
						right={0}
						height="112px"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0517.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0517.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0517.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0517.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0517.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0517.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/CAVC0517.jpg?v=2025-02-07T12%3A10%3A33.270Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					align-items="center"
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					hover-transform="translateY(-10px)"
					padding="0px 0px 0px 0px"
					justify-content="center"
					overflow-x="hidden"
					overflow-y="hidden"
					position="relative"
					display="flex"
				>
					<Image
						min-height="100%"
						object-fit="cover"
						display="block"
						top="auto"
						left={0}
						right={0}
						bottom="0px"
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/Danglo_strangerseyes.jpg?v=2025-02-07T22:44:51.095Z"
						position="relative"
						width="112px"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Danglo_strangerseyes.jpg?v=2025-02-07T22%3A44%3A51.095Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Danglo_strangerseyes.jpg?v=2025-02-07T22%3A44%3A51.095Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Danglo_strangerseyes.jpg?v=2025-02-07T22%3A44%3A51.095Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Danglo_strangerseyes.jpg?v=2025-02-07T22%3A44%3A51.095Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Danglo_strangerseyes.jpg?v=2025-02-07T22%3A44%3A51.095Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Danglo_strangerseyes.jpg?v=2025-02-07T22%3A44%3A51.095Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Danglo_strangerseyes.jpg?v=2025-02-07T22%3A44%3A51.095Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					overflow-y="hidden"
					padding="0px 0px 0px 0px"
					display="flex"
					justify-content="center"
					overflow-x="hidden"
					position="relative"
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					hover-transform="translateY(-10px)"
					align-items="center"
				>
					<Image
						top="auto"
						left={0}
						bottom="0px"
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/AuroraEngine.jpg?v=2025-02-07T22:46:35.969Z"
						position="relative"
						display="block"
						min-height="100%"
						object-fit="cover"
						width="112px"
						right={0}
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AuroraEngine.jpg?v=2025-02-07T22%3A46%3A35.969Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AuroraEngine.jpg?v=2025-02-07T22%3A46%3A35.969Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AuroraEngine.jpg?v=2025-02-07T22%3A46%3A35.969Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AuroraEngine.jpg?v=2025-02-07T22%3A46%3A35.969Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AuroraEngine.jpg?v=2025-02-07T22%3A46%3A35.969Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AuroraEngine.jpg?v=2025-02-07T22%3A46%3A35.969Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/AuroraEngine.jpg?v=2025-02-07T22%3A46%3A35.969Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					align-items="center"
					justify-content="center"
					display="flex"
					overflow-x="hidden"
					overflow-y="hidden"
					position="relative"
					hover-transform="translateY(-10px)"
					padding="0px 0px 0px 0px"
				>
					<Image
						bottom="0px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/kayyoung.jpg?v=2025-02-07T22:48:06.196Z"
						object-fit="cover"
						position="relative"
						display="block"
						width="112px"
						top="auto"
						right={0}
						min-height="100%"
						left={0}
						height="112px"
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/kayyoung.jpg?v=2025-02-07T22%3A48%3A06.196Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/kayyoung.jpg?v=2025-02-07T22%3A48%3A06.196Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/kayyoung.jpg?v=2025-02-07T22%3A48%3A06.196Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/kayyoung.jpg?v=2025-02-07T22%3A48%3A06.196Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/kayyoung.jpg?v=2025-02-07T22%3A48%3A06.196Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/kayyoung.jpg?v=2025-02-07T22%3A48%3A06.196Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/kayyoung.jpg?v=2025-02-07T22%3A48%3A06.196Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					hover-transform="translateY(-10px)"
					align-items="center"
					display="flex"
					overflow-x="hidden"
					overflow-y="hidden"
					position="relative"
					padding="0px 0px 0px 0px"
					justify-content="center"
				>
					<Image
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/haileybeavis.jpg?v=2025-02-07T22:49:13.167Z"
						display="block"
						width="112px"
						bottom="0px"
						right={0}
						min-height="100%"
						object-fit="cover"
						position="relative"
						top="auto"
						left={0}
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/haileybeavis.jpg?v=2025-02-07T22%3A49%3A13.167Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/haileybeavis.jpg?v=2025-02-07T22%3A49%3A13.167Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/haileybeavis.jpg?v=2025-02-07T22%3A49%3A13.167Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/haileybeavis.jpg?v=2025-02-07T22%3A49%3A13.167Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/haileybeavis.jpg?v=2025-02-07T22%3A49%3A13.167Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/haileybeavis.jpg?v=2025-02-07T22%3A49%3A13.167Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/haileybeavis.jpg?v=2025-02-07T22%3A49%3A13.167Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					hover-transform="translateY(-10px)"
					align-items="center"
					display="flex"
					overflow-x="hidden"
					overflow-y="hidden"
					position="relative"
					padding="0px 0px 0px 0px"
					justify-content="center"
				>
					<Image
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/Frankson.jpg?v=2025-02-07T22:51:21.593Z"
						display="block"
						width="112px"
						bottom="0px"
						right={0}
						min-height="100%"
						object-fit="cover"
						position="relative"
						top="auto"
						left={0}
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Frankson.jpg?v=2025-02-07T22%3A51%3A21.593Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Frankson.jpg?v=2025-02-07T22%3A51%3A21.593Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Frankson.jpg?v=2025-02-07T22%3A51%3A21.593Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Frankson.jpg?v=2025-02-07T22%3A51%3A21.593Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Frankson.jpg?v=2025-02-07T22%3A51%3A21.593Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Frankson.jpg?v=2025-02-07T22%3A51%3A21.593Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/Frankson.jpg?v=2025-02-07T22%3A51%3A21.593Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
				<Box
					transform="translateY(0px)"
					transition="transform 0.2s ease-in-out 0s"
					hover-transform="translateY(-10px)"
					align-items="center"
					display="flex"
					overflow-x="hidden"
					overflow-y="hidden"
					position="relative"
					padding="0px 0px 0px 0px"
					justify-content="center"
				>
					<Image
						height="112px"
						src="https://uploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0126.jpg?v=2025-02-07T22:53:12.475Z"
						display="block"
						width="112px"
						bottom="0px"
						right={0}
						min-height="100%"
						object-fit="cover"
						position="relative"
						top="auto"
						left={0}
						srcSet="https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0126.jpg?v=2025-02-07T22%3A53%3A12.475Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0126.jpg?v=2025-02-07T22%3A53%3A12.475Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0126.jpg?v=2025-02-07T22%3A53%3A12.475Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0126.jpg?v=2025-02-07T22%3A53%3A12.475Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0126.jpg?v=2025-02-07T22%3A53%3A12.475Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0126.jpg?v=2025-02-07T22%3A53%3A12.475Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/6798e2f49e74900024005e2d/images/WN0126.jpg?v=2025-02-07T22%3A53%3A12.475Z&quality=85&w=3200 3200w"
						sizes="(max-width: 479px) 100vw,(max-width: 767px) 100vw,(max-width: 991px) 100vw,(max-width: 1199px) 100vw,100vw"
					/>
				</Box>
			</Box>
			<Box
				lg-align-items="center"
				lg-margin="0px 0px 0px 0px"
				sm-padding="0px 0px 0px 0px"
				justify-content="space-between"
				lg-padding="16px 16px 16px 16px"
				display="flex"
				flex-direction="row"
				lg-width="100%"
				padding="16px 55% 16px 16px"
				lg-order="1"
				width="100%"
				align-items="flex-start"
				sm-margin="0px 0px 0px 0px"
			>
				<Box display="flex" flex-direction="column" overflow="visible" width="800px">
					<Text
						margin="0px 0px 0px 0px"
						color="--darkL2"
						font="--base"
						lg-text-align="center"
						md-text-align="left"
					>
						This page showcases a selection of diverse projects that{" "}
						<Strong>
							Pantry Mastering
						</Strong>
						{" "}has worked on over the past few years. From full orchestral mixes and cinematic trailer albums to indie-folk, jazz, and dance tracks, our mastering and mixing expertise spans a wide range of genres. Each project represents a unique sonic identity, carefully refined to meet the highest production standards. Whether it's bringing warmth and clarity to intimate acoustic recordings or delivering punch and energy to electronic productions, our goal is always to enhance the artist’s vision with precision and musicality.
					</Text>
				</Box>
			</Box>
		</Section>
		<Section
			margin="0 0 0 0"
			padding="16px 0 16px 0"
			box-sizing="border-box"
			quarkly-title="Footer"
			justify-content="center"
		>
			<Override
				slot="SectionContent"
				width="100%"
				margin="0px 32px 0px 32px"
				md-margin="0px 16px 0px 16px"
				min-width="auto"
			/>
			<Box
				display="grid"
				grid-gap="32px"
				width="100%"
				grid-template-columns="repeat(2, 1fr)"
				sm-grid-gap="16px"
			>
				<Box display="flex" align-items="center" sm-flex-wrap="wrap">
					<Image src="https://uploads.quarkly.io/5f44d0da669357001e60ed14/images/default-website-quarkly-logo-grey.svg?v=2020-11-06T17:24:35.270Z" width="28px" height="28px" />
					<Link
						white-space="nowrap"
						font="--base"
						opacity="0.6"
						text-decoration-line="initial"
						text-align="left"
						margin="1px 0px 0px 10px"
						hover-text-decoration-line="underline"
						href="https://quarkly.io/"
						color="--dark"
					>
						Made on Quarkly
					</Link>
				</Box>
				<SocialMedia instagram="https://www.instagram.com/pantrymastering?igsh=MWJnbzF4cjVlb3Fhbw%3D%3D&utm_source=qr" justify-content="flex-end">
					<Override slot="link" background="none" border-radius="50%" />
					<Override slot="icon" color="--dark" />
				</SocialMedia>
			</Box>
		</Section>
		<Link
			font={"--capture"}
			font-size={"10px"}
			position={"fixed"}
			bottom={"12px"}
			right={"12px"}
			z-index={"4"}
			border-radius={"4px"}
			padding={"5px 12px 4px"}
			background-color={"--dark"}
			opacity={"0.6"}
			hover-opacity={"1"}
			color={"--light"}
			cursor={"pointer"}
			transition={"--opacityOut"}
			quarkly-title={"Badge"}
			text-decoration-line={"initial"}
			href={"https://quarkly.io/"}
			target={"_blank"}
		>
			Made on Quarkly
		</Link>
	</Theme>;
});